import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminClientsCount = z.any()
export type TagsGetAdminClientsCount = z.infer<typeof tagsGetAdminClientsCount>

export const querystringGetAdminClientsCount = z.object({ "page": z.string().optional(), "perPage": z.string().optional(), "search": z.string().optional() })
export type QuerystringGetAdminClientsCount = z.infer<typeof querystringGetAdminClientsCount>

export const responseGetAdminClientsCount = z.object({ "payload": z.object({ "count": z.number() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminClientsCount = z.infer<typeof responseGetAdminClientsCount>

interface IGetAdminClientsCount extends BaseMethodType {
  tags: TagsGetAdminClientsCount,
  querystring: QuerystringGetAdminClientsCount,
  response: ResponseGetAdminClientsCount
}
export const URL = '/admin/clients/count'
export const validation = {
  get: {
    tags: tagsGetAdminClientsCount,
    querystring: querystringGetAdminClientsCount,
    response: responseGetAdminClientsCount
  }
}
export interface AdminClientsCount extends BaseRouteType {
  get: IGetAdminClientsCount
}